// contributors-a2
//
// Purpose: Community contributor preset categories (A2)
//
// This module:
// - Exports preset categories: Krmailence through august

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const contributorCategoriesA2: InputPresetCategory[] = [
	{
		name: "Krmailence's Presets",
		presets: toNameMap([
			{
				name: "Fake Arpeggiator",
				generalMidi: false,
				tags: ["supersaw", "krmailence"],
				settings: {
					type: "supersaw",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter", "reverb"],
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 50,
					spread: 100,
					shape: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: true,
							waveform: 1,
							steps: 2,
						},
					],
				},
			},
			{
				name: "NV-0903 Vocalizations",
				generalMidi: false,
				tags: ["fm", "fm4op", "krmailence", "featured"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 13,
					vibrato: "custom",
					vibratoDepth: 0.52,
					vibratoDelay: 11,
					vibratoSpeed: 11,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 2 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 2 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1 },
					],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 7,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "WFUT's In-Out Lead",
				generalMidi: false,
				tags: ["pwm", "krmailence"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					effects: ["chord type", "note filter", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 }],
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.167,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 47,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Compress'd Shaky S-Saw",
				generalMidi: false,
				tags: ["supersaw", "krmailence"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 420.45, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 9513.66,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 420.45, linearGain: 1.4142 },
					],
					effects: ["pitch shift", "vibrato", "note filter", "distortion"],
					pitchShiftSemitones: 12,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 1,
						},
					],
					distortion: 29,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 27,
					decimalOffset: 0,
					dynamism: 50,
					spread: 92,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "Squirmy Guitar",
				generalMidi: false,
				tags: ["chip", "chipwave", "krmailence"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6138.63, linearGain: 2.8284 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					detuneCents: 40,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 4 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 4 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "wackybox buzz wave",
					unison: "shimmer",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 2.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherFrequency",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 1.9,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 3,
							perEnvelopeLowerBound: 1.9,
							perEnvelopeUpperBound: 2,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Electric S-Saw Bass",
				generalMidi: false,
				tags: ["supersaw", "krmailence"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 2 },
					],
					effects: ["note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 }],
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 45,
					decimalOffset: 0,
					dynamism: 83,
					spread: 0,
					shape: 33,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Distorted Chords",
				generalMidi: false,
				tags: ["supersaw", "krmailence"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 2,
						},
					],
					granular: 1,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 100,
					aliases: false,
					panDelay: 0,
					chorus: 100,
					echoSustain: 57,
					echoDelayBeats: 0.75,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 100,
					spread: 42,
					shape: 17,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: true,
							perEnvelopeSpeed: 0.3333,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Falter Chords",
				generalMidi: false,
				tags: ["harmonics", "krmailence"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
					],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					panDelay: 0,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -12,
					harmonics: [
						100, 57, 57, 29, 14, 0, 14, 29, 14, 29, 14, 0, 0, 14, 14, 14, 14, 0, 0, 14,
						0, 14, 14, 14, 0, 14, 14, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM 6-Operator Saxophone",
				generalMidi: false,
				tags: ["fm", "fm6op", "krmailence"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 5.6569 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 5.6569 }],
					effects: ["vibrato"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 9, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.25,
							perEnvelopeLowerBound: 1.2,
							perEnvelopeUpperBound: 1.9,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 0.1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "FM Electric Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "krmailence"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1 },
						{ type: "peak", cutoffHz: 500, linearGain: 1 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1 },
						{ type: "peak", cutoffHz: 500, linearGain: 1 },
					],
					effects: ["note filter", "distortion", "bitcrusher", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sliding Lead",
				generalMidi: false,
				tags: ["chip", "chipwave", "krmailence", "featured"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 19,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 71,
					aliases: false,
					panDelay: 0,
					chorus: 86,
					echoSustain: 57,
					echoDelayBeats: 0.75,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "nerdbox unnamed 1",
					unison: "hold",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 7,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "distortion",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Fuzzy Distortion Lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "krmailence", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 }],
					effects: [
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"bitcrusher",
						"echo",
						"reverb",
					],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 24,
					detuneCents: 50,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 86,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 6,
					algorithm: "1←3←4 2←5←6",
					feedbackType: "1→5 2→6 3→4",
					feedbackAmplitude: 9,
					operators: [
						{
							frequency: "0.5×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "0.25×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 1, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 12, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "bitcrusherFrequency",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 5.5,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 0.6667,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Nearfull S-Saw Lead",
				generalMidi: false,
				tags: ["supersaw", "krmailence"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
					],
					effects: ["detune"],
					detuneCents: 50,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 48,
					decimalOffset: 0,
					dynamism: 83,
					spread: 75,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "Faux Saw Strings",
				generalMidi: false,
				tags: ["supersaw", "krmailence"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 125, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 125, linearGain: 11.3137 },
					],
					effects: ["detune", "echo"],
					detuneCents: 50,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 83,
					spread: 25,
					shape: 83,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 0.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Evil FM Keys",
				generalMidi: false,
				tags: ["fm", "fm4op", "krmailence"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 2.8284,
						},
					],
					effects: ["note filter", "distortion"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 1,
						},
					],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4)",
					feedbackType: "ALL",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "~2×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 3, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "12×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "krmailence"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "krmailence"], settings: {} },
		]),
	},
	{
		name: "ia.kisha's Presets",
		presets: toNameMap([
			{
				name: "Vague Memory Chimes",
				generalMidi: false,
				tags: ["chip", "chipwave", "ia.kisha"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"panning",
						"transition type",
						"detune",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 24,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 10,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					unison: "piano",
					wave: "triangle",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Crushed Saw Pluck",
				generalMidi: false,
				tags: ["supersaw", "ia.kisha", "featured"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [{ type: "peak", cutoffHz: 6727.17, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "peak", cutoffHz: 6727.17, linearGain: 0.125 }],
					eqSubFilters1: [],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 14,
					pan: 0,
					panDelay: 10,
					chorus: 100,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 11,
					decimalOffset: 0,
					dynamism: 33,
					spread: 17,
					shape: 100,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
					isDrum: false,
				},
			},
			{
				name: "Keeper Lead",
				generalMidi: false,
				tags: ["chip", "chipwave", "ia.kisha"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"panning",
						"transition type",
						"detune",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 24,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 10,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					unison: "warbled",
					wave: "sawtooth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "Celebration Bells",
				generalMidi: false,
				tags: ["chip", "chipwave", "ia.kisha"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"panning",
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: 16,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					pan: 0,
					panDelay: 10,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					unison: "hecking gosh",
					wave: "spiky",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 6,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "none",
							envelope: "twang 1",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Celestina",
				generalMidi: false,
				tags: ["fm", "fm4op", "ia.kisha"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"chord type",
						"detune",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 12,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					pan: 0,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 94,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 1",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
					],
					isDrum: false,
				},
			},
			{
				name: "Game Sine",
				generalMidi: false,
				tags: ["harmonics", "ia.kisha"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 2.8284,
						},
					],
					effects: ["panning", "chord type", "note filter", "bitcrusher"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 57,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 86, 71, 71, 71, 57, 57, 57, 43, 57, 71, 57, 43, 43, 29, 29, 29, 29, 29,
						29, 29, 29, 29, 43, 43, 43, 43, 43,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
						},
						{
							target: "bitcrusherFrequency",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Carnival Flute",
				generalMidi: false,
				tags: ["chip", "chipwave", "ia.kisha"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 297.3,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 297.3,
							linearGain: 0.125,
						},
					],
					eqSubFilters1: [],
					effects: ["panning", "chorus", "reverb"],
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 48,
					fadeInSeconds: 0.075,
					fadeOutTicks: 96,
					wave: "flute",
					unison: "warbled",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "unison", envelope: "blip 2" }],
					isDrum: false,
				},
			},
			{
				name: "Dissonant Tooth",
				generalMidi: false,
				tags: ["chip", "chipwave", "ia.kisha"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 }],
					effects: ["panning", "detune", "note filter", "chorus", "reverb"],
					detuneCents: 17,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					pan: 0,
					panDelay: 0,
					chorus: 71,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "sawtooth",
					unison: "weird octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "chorus",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "FM Melancholy",
				generalMidi: false,
				tags: ["fm", "fm4op", "ia.kisha"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "note filter", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 }],
					pan: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.167,
					reverb: 90,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 72,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 12,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteVolume", envelope: "swell -1" },
						{ target: "operatorAmplitude", envelope: "swell 2", index: 2 },
						{ target: "feedbackAmplitude", envelope: "twang 3" },
						{ target: "noteFilterFreq", envelope: "swell 1", index: 0 },
					],
					isDrum: false,
				},
			},
			// JukeBox 0.1.6
			{
				name: "Unstable Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "ia.kisha"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8423.54, linearGain: 2.8284 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "detune", "vibrato", "note filter", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -60,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					panDelay: 0,
					chorus: 100,
					fadeInSeconds: 0.075,
					fadeOutTicks: 96,
					wave: "brucebox pokey 4bit lfsr",
					unison: "energetic",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "chorus",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 8.5,
							perEnvelopeLowerBound: 1.2,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
						{
							target: "vibratoDepth",
							envelope: "lfo",
							inverse: true,
							perEnvelopeSpeed: 3.5,
							perEnvelopeLowerBound: 1.4,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Spoopy Organ",
				generalMidi: false,
				tags: ["harmonics", "ia.kisha"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.7071,
						},
					],
					effects: ["transition type", "vibrato", "note filter", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 250, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 250, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					panDelay: 10,
					chorus: 100,
					reverb: 71,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 86, 100, 57, 43, 0, 86, 29, 14, 29, 57, 29, 14, 29, 86, 29, 43,
						14, 43, 14, 43, 29, 57, 29, 14, 14, 14,
					],
					unison: "double octave",
					envelopes: [],
				},
			},
			// { name: "", generalMidi: false, tags:["", "ia.kisha"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ia.kisha"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ia.kisha"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ia.kisha"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "ia.kisha"], settings: {} },
		]),
	},
	{
		name: "KoraCaesh's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.0--------------
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
			// { name: "", generalMidi: false, tags:[""], settings: {} },
		]),
	},
	{
		name: "snowirei's Presets",
		presets: toNameMap([
			{
				name: "weird choir",
				generalMidi: false,
				tags: ["harmonics", "snowirei"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["panning", "transition type", "vibrato", "chorus", "reverb"],
					transition: "slide in pattern",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					chorus: 100,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						100, 86, 100, 29, 29, 29, 29, 29, 29, 14, 0, 0, 0, 0, 29, 29, 29, 29, 57,
						43, 14, 0, 71, 14, 0, 43, 43, 29,
					],
					unison: "triple octave",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			// -------------JukeBox 0.2.0--------------
			{
				name: "cat-string",
				generalMidi: false,
				tags: ["chip", "chipwave", "snowirei"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "note filter", "echo"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 0.25,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "modbox atari bass",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 15,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteVolume", envelope: "blip 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "flare 1",
						},
					],
				},
			},
			{
				name: "chirp beep",
				generalMidi: false,
				tags: ["fm", "fm4op", "snowirei"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 7,
					noteFilter: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7586.61, linearGain: 11.3137 }],
					panDelay: 0,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.917,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←2←3←4",
					feedbackType: "(1 2 3)→4",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "~4×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "12×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "intense bits",
				generalMidi: false,
				tags: ["chip", "customchip", "snowirei"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 }],
					effects: ["chord type", "bitcrusher", "chorus", "reverb"],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 100,
					panDelay: 0,
					chorus: 29,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "fifth",
					customChipWave: {
						"0": 0,
						"1": -1,
						"2": 13,
						"3": -8,
						"4": -1,
						"5": -21,
						"6": -2,
						"7": 0,
						"8": 0,
						"9": -21,
						"10": -1,
						"11": -5,
						"12": -7,
						"13": 0,
						"14": 21,
						"15": 8,
						"16": 0,
						"17": 2,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": -2,
						"22": 21,
						"23": 13,
						"24": 13,
						"25": 6,
						"26": 12,
						"27": 12,
						"28": 12,
						"29": 12,
						"30": -9,
						"31": 2,
						"32": 2,
						"33": 2,
						"34": 2,
						"35": 2,
						"36": 21,
						"37": 21,
						"38": 22,
						"39": 22,
						"40": 22,
						"41": 22,
						"42": 22,
						"43": 22,
						"44": 18,
						"45": 17,
						"46": 14,
						"47": 0,
						"48": 17,
						"49": -4,
						"50": 0,
						"51": 15,
						"52": -1,
						"53": -20,
						"54": -1,
						"55": 0,
						"56": 0,
						"57": -1,
						"58": -1,
						"59": -1,
						"60": -3,
						"61": -1,
						"62": 16,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "supersaw of mystery",
				generalMidi: false,
				tags: ["supersaw", "snowirei"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 148.65,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 16,
					discreteEnvelope: true,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 148.65,
							linearGain: 11.3137,
						},
						{ type: "peak", cutoffHz: 500, linearGain: 2.8284 },
					],
					effects: ["vibrato", "reverb"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 84,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 46,
					decimalOffset: 0,
					dynamism: 67,
					spread: 67,
					shape: 50,
					envelopes: [{ target: "vibratoDepth", envelope: "blip 1" }],
				},
			},
			{
				name: "supersaw of mystery 2",
				generalMidi: false,
				tags: ["supersaw", "snowirei"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "chorus", "echo", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 3,
					noteFilter: [{ type: "low-pass", cutoffHz: 9140.55, linearGain: 2 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9140.55, linearGain: 2 }],
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1.25,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					pulseWidth: 44,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 67,
					envelopes: [{ target: "noteFilterFreq", envelope: "flute 3", index: 0 }],
				},
			},
			{
				name: "water-ish plup",
				generalMidi: false,
				tags: ["pickedstring", "snowirei"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 2.8284,
						},
					],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
					],
					panDelay: 0,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 0, 0, 0, 86, 71, 71, 29, 29, 43, 43, 43, 0, 0, 0, 86, 86, 71, 71, 57,
						43, 43, 43, 57, 14, 14, 14, 0,
					],
					unison: "none",
					stringSustain: 79,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "flare 2" }],
				},
			},
			{
				name: "brass-like FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "snowirei"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					panDelay: 0,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 (3 (4",
					feedbackType: "1↔2 3↔4",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "feedbackAmplitude", envelope: "decay 1" }],
				},
			},
			{
				name: "dist. chirp beep",
				generalMidi: false,
				tags: ["fm", "fm6op", "snowirei"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 0.125,
						},
					],
					effects: ["echo", "reverb"],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 0.583,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4(2←5 3←6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~4×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 8, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "19×", amplitude: 0, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "FM strange piano",
				generalMidi: false,
				tags: ["fm", "fm4op", "snowirei"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "bitcrusher", "chorus", "reverb"],
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1 }],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 29,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "jackenstein FM",
				generalMidi: false,
				tags: ["fm", "fm4op", "snowirei"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 25,
					panDelay: 0,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→4",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "~4×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 0,
							waveform: "pulse width",
							pulseWidth: 8,
						},
						{
							frequency: "0.12×",
							amplitude: 0,
							waveform: "pulse width",
							pulseWidth: 9,
						},
						{ frequency: "0.12×", amplitude: 0, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "square of mystery",
				generalMidi: false,
				tags: ["chip", "chipwave", "snowirei"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
					],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 77,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "unison", envelope: "blip 1" }],
				},
			},
			{
				name: "the BAD guitar",
				generalMidi: false,
				tags: ["pickedstring", "snowirei"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "note filter", "distortion", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					harmonics: [
						71, 100, 71, 71, 71, 71, 71, 71, 57, 57, 71, 86, 86, 86, 86, 57, 86, 57, 71,
						71, 71, 71, 43, 57, 57, 57, 57, 0,
					],
					unison: "octave",
					stringSustain: 100,
					envelopes: [],
				},
			},
			// { name: "", generalMidi: false, tags:["", "snowirei"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "snowirei"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "snowirei"], settings: {} },
		]),
	},
	{
		name: "HappyLemonLime's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.0.1--------------
			{
				name: "cave oo",
				generalMidi: false,
				tags: ["fm", "fm6op", "happylemonlime"],
				settings: {
					type: "FM6op",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					effects: ["panning", "transition type", "chord type", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pan: 0,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 6,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "twang 3" }],
					isDrum: false,
				},
			},
			{
				name: "Melancholy Piano",
				generalMidi: false,
				tags: ["pickedstring", "happylemonlime"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 }],
					effects: ["transition type", "detune", "vibrato", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 20,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 0,
					vibratoSpeed: 2,
					vibratoType: 1,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						86, 100, 86, 71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 57, 57, 43, 43, 43, 43,
						43, 43, 29, 29, 29, 29, 43, 43, 29,
					],
					unison: "custom",
					unisonVoices: 1,
					unisonSpread: 0,
					unisonOffset: -0.1,
					unisonExpression: 1.4,
					unisonSign: 1,
					stringSustain: 71,
					envelopes: [
						{ target: "vibratoDepth", envelope: "twang 1" },
						{
							target: "noteVolume",
							envelope: "linear 1",
						},
					],
				},
			},
			{
				name: "Sapphire",
				generalMidi: false,
				tags: ["chip", "chipwave", "happylemonlime"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "bitcrusher", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					echoSustain: 29,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "alto sax",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Mushrooms",
				generalMidi: false,
				tags: ["chip", "chipwave", "happylemonlime"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["chord type", "vibrato", "echo", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 0.25,
					reverb: 13,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					wave: "lemmbox HD triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 1000,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteVolume", envelope: "punch" },
						{
							target: "noteVolume",
							envelope: "twang 1",
						},
					],
				},
			},
			{
				name: "Distant Chip Sax",
				generalMidi: false,
				tags: ["chip", "chipwave", "happylemonlime", "featured"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 125, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 125, linearGain: 2.8284 }],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 16,
					vibratoSpeed: 8,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "alto sax",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Picked Sine Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "happylemonlime"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 }],
					effects: ["transition type", "echo"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sine",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteVolume", envelope: "decay 1" }],
				},
			},
			{
				name: "Artifact Chip",
				generalMidi: false,
				tags: ["chip", "chipwave", "happylemonlime"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"vibrato",
						"bitcrusher",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 9,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					wave: "alto sax",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.1--------------
			{
				name: "Bowed Saw",
				generalMidi: false,
				tags: ["supersaw", "happylemonlime"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 1 }],
					effects: [
						"transition type",
						"vibrato",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					granular: 6,
					grainSize: 50,
					grainAmounts: 6,
					grainRange: 28,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 57,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 83,
					spread: 58,
					shape: 50,
					envelopes: [
						{
							target: "granular",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 7.5,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 0.1,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Magic Wind",
				generalMidi: false,
				tags: ["spectrum", "happylemonlime", "ambience"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.3536,
						},
					],
					effects: ["granular", "chorus", "echo", "reverb"],
					granular: 4,
					grainSize: 1,
					grainAmounts: 10,
					grainRange: 2,
					panDelay: 0,
					chorus: 100,
					echoSustain: 14,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					spectrum: [
						100, 29, 43, 0, 0, 29, 0, 71, 14, 14, 43, 71, 0, 43, 57, 0, 57, 0, 100, 43,
						0, 100, 14, 29, 14, 14, 14, 57, 0, 29,
					],
					unison: "rising",
					envelopes: [],
				},
			},
			{
				name: "Forgotten Bell",
				generalMidi: false,
				tags: ["fm", "fm4op", "happylemonlime"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"chord type",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
						"ring mod",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 2,
					noteFilter: [],
					granular: 4,
					grainSize: 1,
					grainAmounts: 10,
					grainRange: 8,
					ringMod: 100,
					ringModHz: 73,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 0,
					chorus: 29,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Shredder Guitar",
				generalMidi: false,
				tags: ["pickedstring", "happylemonlime", "featured", "distortion"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.5,
						},
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.32,
					vibratoDelay: 19,
					vibratoSpeed: 5,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 1,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 0,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 0.75,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 50,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{ target: "stringSustain", envelope: "note size" },
						{ target: "noteVolume", envelope: "note size" },
						{ target: "noteFilterAllFreqs", envelope: "punch" },
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "happylemonlime"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "happylemonlime"], settings: {} },
		]),
	},
	{
		name: "spendog's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.2.0--------------
			{
				name: "ethereal organ stab",
				generalMidi: false,
				tags: ["fm", "fm4op", "spendog", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "chorus", "echo", "reverb"],
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 1,
					noteFilter: [],
					panDelay: 10,
					chorus: 100,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "(1 2 3)←4",
					feedbackType: "1⟲ 2⟲ 3⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "pulse bleep",
				generalMidi: false,
				tags: ["chip", "customchip", "spendog", "chiptune", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 17,
					pitchShiftSemitones: 24,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					wave: "1/4 pulse",
					customChipWave: {
						"0": -24,
						"1": -24,
						"2": -24,
						"3": -24,
						"4": -24,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": 22,
						"17": 19,
						"18": 17,
						"19": 14,
						"20": 13,
						"21": 11,
						"22": 9,
						"23": 8,
						"24": 7,
						"25": 6,
						"26": 4,
						"27": 3,
						"28": 2,
						"29": 3,
						"30": 5,
						"31": 6,
						"32": 8,
						"33": 9,
						"34": 9,
						"35": 8,
						"36": 7,
						"37": 5,
						"38": 4,
						"39": 3,
						"40": 3,
						"41": 5,
						"42": 6,
						"43": 4,
						"44": 3,
						"45": 2,
						"46": 4,
						"47": 5,
						"48": 7,
						"49": 9,
						"50": 11,
						"51": 12,
						"52": 12,
						"53": 13,
						"54": 13,
						"55": 14,
						"56": 14,
						"57": 15,
						"58": 17,
						"59": 18,
						"60": 20,
						"61": 22,
						"62": 23,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "pitchShift", envelope: "blip 3" }],
				},
			},
			// -------------JukeBox 0.2.0--------------
			{
				name: "mother 3- buzzy",
				generalMidi: false,
				tags: ["chip", "customchip", "spendog", "chiptune", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 1,
					monoChordTone: 1,
					pitchShiftSemitones: 12,
					detuneCents: 4,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 19027.31,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 19027.31,
							linearGain: 2.8284,
						},
					],
					distortion: 0,
					aliases: false,
					panDelay: 10,
					chorus: 0,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.1,
					unisonOffset: 0.167,
					unisonExpression: 1,
					unisonSign: 1,
					customChipWave: {
						"0": 24,
						"1": 22,
						"2": 20,
						"3": 18,
						"4": 16,
						"5": 11,
						"6": 7,
						"7": 4,
						"8": 2,
						"9": 0,
						"10": -1,
						"11": -3,
						"12": -5,
						"13": -5,
						"14": -7,
						"15": -8,
						"16": -10,
						"17": -10,
						"18": -10,
						"19": -11,
						"20": -11,
						"21": -11,
						"22": -11,
						"23": -12,
						"24": -13,
						"25": -14,
						"26": -14,
						"27": -15,
						"28": -15,
						"29": -15,
						"30": -15,
						"31": -15,
						"32": -15,
						"33": -15,
						"34": -16,
						"35": -16,
						"36": -16,
						"37": -16,
						"38": -16,
						"39": -17,
						"40": -17,
						"41": -18,
						"42": -18,
						"43": -18,
						"44": -19,
						"45": -19,
						"46": -19,
						"47": -19,
						"48": -20,
						"49": -20,
						"50": -21,
						"51": -21,
						"52": -21,
						"53": -22,
						"54": -22,
						"55": -22,
						"56": -22,
						"57": -22,
						"58": -22,
						"59": -22,
						"60": -22,
						"61": -23,
						"62": -23,
						"63": -23,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "detune",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "muted overdrive guitar",
				generalMidi: false,
				tags: ["pickedstring", "spendog", "distortion", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 1000,
							linearGain: 0.25,
						},
					],
					effects: ["note filter", "distortion", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 0,
					envelopes: [],
				},
			},
			{
				name: "mini chip banjo",
				generalMidi: false,
				tags: ["chip", "chipwave", "spendog", "picked", "chiptune", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chord type", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					strumParts: 1,
					panDelay: 0,
					reverb: 42,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					wave: "electric guitar",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteVolume", envelope: "twang 1" }],
				},
			},
			{
				name: "crush-pluck",
				generalMidi: false,
				tags: ["chip", "chipwave", "spendog", "featured", "picked", "chiptune", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "bitcrusher", "echo", "reverb"],
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 74,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "detune",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 7,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "ethereal saw strings",
				generalMidi: false,
				tags: ["chip", "chipwave", "spendog", "string", "chiptune", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 7,
					eqSubFilters0: [],
					effects: ["transition type", "chord type", "detune", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					detuneCents: 0,
					panDelay: 0,
					chorus: 100,
					echoSustain: 43,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					wave: "double saw",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "unstable neobass",
				generalMidi: false,
				tags: ["fm", "fm4op", "spendog", "bass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.5,
						},
					],
					effects: ["distortion"],
					distortion: 0,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 2,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "pulse kick",
				generalMidi: false,
				tags: ["chip", "chipwave", "spendog", "kick"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "pitch shift", "detune"],
					transition: "slide",
					clicklessTransition: false,
					slideTicks: 3,
					pitchShiftSemitones: 24,
					detuneCents: 200,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					wave: "double pulse",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 16,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "pitchShift", envelope: "twang -1" },
						{ target: "detune", envelope: "twang -1" },
						{ target: "noteVolume", envelope: "punch" },
						{ target: "noteVolume", envelope: "twang 2" },
					],
				},
			},
			{
				name: "hard hitter metal guitar",
				generalMidi: false,
				tags: ["pickedstring", "spendog", "distortion", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.25 },
					],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 1 }],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 86, 86, 86, 86, 71, 71, 71, 71, 71, 71, 71, 71, 71, 71, 57,
						57, 57, 57, 57, 57, 57, 57, 57, 57, 57,
					],
					unison: "none",
					stringSustain: 29,
					envelopes: [{ target: "noteFilterFreq", envelope: "note size", index: 0 }],
				},
			},
			{
				name: "ascending chip supersaw",
				generalMidi: false,
				tags: ["chip", "customchip", "spendog", "string", "chiptune", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "double saw",
					unison: "custom",
					unisonVoices: 9,
					unisonSpread: 0.102,
					unisonOffset: 0,
					unisonExpression: 2,
					unisonSign: 0.02,
					customChipWave: {
						"0": 24,
						"1": 16,
						"2": 15,
						"3": 14,
						"4": 13,
						"5": 21,
						"6": 20,
						"7": 19,
						"8": 18,
						"9": 18,
						"10": 17,
						"11": 16,
						"12": 23,
						"13": 23,
						"14": 22,
						"15": 21,
						"16": -2,
						"17": -3,
						"18": -5,
						"19": -7,
						"20": -8,
						"21": 9,
						"22": 8,
						"23": 7,
						"24": 6,
						"25": 6,
						"26": 18,
						"27": 17,
						"28": 16,
						"29": 15,
						"30": 15,
						"31": 13,
						"32": 12,
						"33": -18,
						"34": -19,
						"35": -19,
						"36": -21,
						"37": -22,
						"38": -23,
						"39": -5,
						"40": -6,
						"41": -6,
						"42": -7,
						"43": -8,
						"44": -9,
						"45": -9,
						"46": -10,
						"47": -11,
						"48": -12,
						"49": -12,
						"50": -13,
						"51": -14,
						"52": -15,
						"53": -15,
						"54": -3,
						"55": -4,
						"56": -5,
						"57": -5,
						"58": -6,
						"59": -7,
						"60": -8,
						"61": -8,
						"62": -22,
						"63": -23,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "moonsoft bass",
				generalMidi: false,
				tags: ["chip", "customchip", "spendog", "bass", "chiptune", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["transition type", "chord type", "vibrato", "bitcrusher"],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 19,
						"2": 15,
						"3": 11,
						"4": 9,
						"5": 5,
						"6": 3,
						"7": 0,
						"8": -4,
						"9": -10,
						"10": -13,
						"11": -16,
						"12": -19,
						"13": -23,
						"14": -24,
						"15": -20,
						"16": -12,
						"17": -8,
						"18": -4,
						"19": -2,
						"20": 1,
						"21": 4,
						"22": -1,
						"23": -3,
						"24": -3,
						"25": 3,
						"26": 5,
						"27": 6,
						"28": 7,
						"29": 4,
						"30": -1,
						"31": -2,
						"32": -1,
						"33": 1,
						"34": 5,
						"35": 1,
						"36": -1,
						"37": 4,
						"38": 7,
						"39": 9,
						"40": 11,
						"41": 13,
						"42": 14,
						"43": 17,
						"44": 16,
						"45": 10,
						"46": 7,
						"47": 3,
						"48": 0,
						"49": -1,
						"50": -2,
						"51": -2,
						"52": -2,
						"53": -2,
						"54": -2,
						"55": -2,
						"56": -2,
						"57": 0,
						"58": 2,
						"59": 13,
						"60": 16,
						"61": 20,
						"62": 22,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "haunted chip harp",
				generalMidi: false,
				tags: ["chip", "customchip", "spendog", "string", "chiptune", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["chord type", "distortion", "bitcrusher", "chorus", "echo", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 65,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "custom",
					unisonVoices: 9,
					unisonSpread: 0.2,
					unisonOffset: 0,
					unisonExpression: 1.4,
					unisonSign: 0,
					customChipWave: {
						"0": -8,
						"1": -10,
						"2": -16,
						"3": -19,
						"4": -22,
						"5": -24,
						"6": -24,
						"7": -24,
						"8": -24,
						"9": -24,
						"10": -24,
						"11": -24,
						"12": -24,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -24,
						"26": -22,
						"27": -21,
						"28": -19,
						"29": -18,
						"30": -16,
						"31": -10,
						"32": 10,
						"33": 11,
						"34": 16,
						"35": 22,
						"36": 23,
						"37": 24,
						"38": 24,
						"39": 24,
						"40": 24,
						"41": 24,
						"42": 24,
						"43": 24,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 22,
						"57": 20,
						"58": 17,
						"59": 15,
						"60": 13,
						"61": 11,
						"62": 8,
						"63": 7,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:["", "spendog"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "spendog"], settings: {} },
		]),
	},
	{
		name: "SomethingOriginal's Presets",
		presets: toNameMap([
			// -------------JukeBox 0.1.0--------------
			{
				name: "FM Light Piano",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["chorus"],
					panDelay: 0,
					chorus: 43,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←3 2←4",
					feedbackType: "2→4",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Doohickey Guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					distortion: 57,
					aliases: false,
					panDelay: 10,
					chorus: 100,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←(2 3←4)",
					feedbackType: "1→2",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 1", index: 2 },
						{
							target: "operatorAmplitude",
							envelope: "swell 3",
							index: 3,
						},
						{ target: "feedbackAmplitude", envelope: "punch" },
					],
				},
			},
			// -------------JukeBox 0.2.0--------------
			{
				name: "FM Chime",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 4 },
					],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 2", index: 1 },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
					],
				},
			},
			{
				name: "fretless bass 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "triazoid synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "peak", cutoffHz: 6727.17, linearGain: 4 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 6727.17, linearGain: 4 }],
					eqSubFilters1: [{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 }],
					eqSubFilters2: [{ type: "peak", cutoffHz: 1414.21, linearGain: 11.3137 }],
					eqSubFilters3: [{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 }],
					eqSubFilters4: [{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 }],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←(3 4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "~1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 3, waveform: "pulse width", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Pulse Trumpet",
				generalMidi: false,
				tags: ["pwm", "somethingoriginal"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					effects: ["detune", "vibrato"],
					detuneCents: 20,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 35,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{
							target: "detune",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			// -------------JukeBox 0.2.1--------------
			{
				name: "Ice Cream Jingle",
				generalMidi: false,
				tags: ["chip", "customchip", "somethingoriginal"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["note filter", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.5 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -7,
						"1": -10,
						"2": -14,
						"3": -13,
						"4": -16,
						"5": -17,
						"6": -19,
						"7": -22,
						"8": -21,
						"9": -20,
						"10": -16,
						"11": -13,
						"12": -12,
						"13": -12,
						"14": -15,
						"15": -14,
						"16": -15,
						"17": -12,
						"18": -12,
						"19": -13,
						"20": -16,
						"21": -20,
						"22": -21,
						"23": -22,
						"24": -19,
						"25": -17,
						"26": -16,
						"27": -13,
						"28": -14,
						"29": -10,
						"30": -7,
						"31": 0,
						"32": 7,
						"33": 10,
						"34": 14,
						"35": 13,
						"36": 16,
						"37": 17,
						"38": 19,
						"39": 22,
						"40": 21,
						"41": 20,
						"42": 16,
						"43": 13,
						"44": 12,
						"45": 12,
						"46": 15,
						"47": 14,
						"48": 15,
						"49": 12,
						"50": 12,
						"51": 13,
						"52": 16,
						"53": 20,
						"54": 21,
						"55": 22,
						"56": 19,
						"57": 17,
						"58": 16,
						"59": 13,
						"60": 14,
						"61": 10,
						"62": 7,
						"63": 0,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "fucked up trumpet",
				generalMidi: false,
				tags: ["fm", "fm6op", "somethingoriginal", "featured"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
					],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 0.0884 },
					],
					noteSubFilters4: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 0.0884 },
					],
					panDelay: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "Custom",
					feedbackType: "2⟲",
					feedbackAmplitude: 4,
					customAlgorithm: { mods: [[2, 4], [3], [], [], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "~2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 7, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.7,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.9,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Fraud Synth",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "quasi-sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "3×", amplitude: 5, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			// -------------JukeBox 0.2.3--------------
			{
				name: "Brutal Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 2 }],
					effects: ["pitch shift", "distortion", "bitcrusher", "chorus", "reverb"],
					pitchShiftSemitones: 0,
					distortion: 86,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 0,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 11, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "punch", index: 3 }],
				},
			},
			{
				name: "FM Soft Piano",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 86,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "2⟲",
					feedbackAmplitude: 1,
					operators: [
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 2", index: 1 },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 3", index: 0 },
					],
				},
			},
			{
				name: "Twinkle Star",
				generalMidi: false,
				tags: ["fm", "fm4op", "somethingoriginal"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 57,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "twang 3", index: 1 }],
				},
			},
			// { name: "", generalMidi: false, tags:["", "somethingoriginal"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "somethingoriginal"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "somethingoriginal"], settings: {} },
		]),
	},
	{
		name: "Minecraft Note Blocks - eggfry",
		presets: toNameMap([
			{
				name: "Golden Bell",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter", "distortion", "reverb"],
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.3536 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.3536 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
					],
				},
			},
			{
				name: "Ice Chime",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry", "featured"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					effects: ["vibrato", "note filter", "granular", "bitcrusher"],
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 9,
					vibratoSpeed: 30,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.5 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.5 },
					],
					granular: 3,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1←3 2←4",
					feedbackType: "2⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "granular",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "vibratoDepth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Clay Flute",
				generalMidi: false,
				tags: ["fm", "fm6op", "eggfry"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 16000, linearGain: 0.1768 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 16000, linearGain: 0.1768 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 4 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.25 },
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 6,
					vibratoSpeed: 30,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
					],
					granular: 1,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.6,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
							index: 4,
						},
						{
							target: "granular",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Wool Guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2 },
					],
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "bitcrusher", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 0,
					vibratoSpeed: 30,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 4 },
					],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 12,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 0,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Wooden Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "detune", "note filter", "distortion", "reverb"],
					pitchShiftSemitones: 24,
					detuneCents: -50,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 8 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 125, linearGain: 1.4142 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 8 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 125, linearGain: 1.4142 },
					],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 24,
					algorithm: "1←(2 3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 19,
							pitchEnvelopeEnd: 72,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Iron Xylophone",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry", "featured"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 8 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 2 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 8 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 2 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
					],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "distortion"],
					detuneCents: -30,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 500, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
					],
					distortion: 43,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←3 2←4",
					feedbackType: "3⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "9×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: true,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 0.2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Glow Ping",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			{
				name: "Emerald Bit",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
					],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "distortion", "bitcrusher", "reverb"],
					detuneCents: -10,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 4000, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 4000, linearGain: 2.8284 },
					],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2←3←4",
					feedbackType: "1→2",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 9, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Hay Banjo",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
					],
					effects: ["chord type", "pitch shift", "note filter", "distortion", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 8000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←(2 3←4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "4×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "14×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1.2,
							discrete: false,
							index: 6,
						},
						{
							target: "noteVolume",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							pitchEnvelopeStart: 24,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Note Block Harp",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1000, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 10,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1000, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.25 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.5 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.25 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.5 },
					],
					distortion: 29,
					aliases: false,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.7,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Pumpkin",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "granular", "distortion", "bitcrusher", "ring mod"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 125, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 2 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
					],
					granular: 1,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					ringMod: 14,
					ringModHz: 68,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 12,
					algorithm: "1←3 2←4",
					feedbackType: "4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.6,
							perEnvelopeUpperBound: 1.4,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 2,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
						},
						{
							target: "ringModulation",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0.9,
							perEnvelopeUpperBound: 1.1,
							discrete: false,
							index: 6,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
						},
						{
							target: "granular",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 72,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "XyloBone",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 4 },
						{ type: "peak", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.25 },
					],
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "granular", "bitcrusher", "echo", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 0,
					vibratoSpeed: 30,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 8000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 8000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.3536 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 250, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.3536 },
					],
					granular: 1,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←3 2←4",
					feedbackType: "ALL",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "5×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterFreq",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "granular",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 20,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Stone Bass",
				generalMidi: false,
				tags: ["spectrum", "eggfry"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.5 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.5 },
					],
					effects: ["pitch shift", "distortion", "bitcrusher", "echo"],
					pitchShiftSemitones: 24,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 71,
					panDelay: 0,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					spectrum: [
						0, 86, 0, 0, 0, 0, 0, 100, 100, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "echoSustain",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.8,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Soul Cow",
				generalMidi: false,
				tags: ["fm", "fm4op", "eggfry"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
					],
					eqSubFilters1: [],
					effects: [
						"detune",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
					],
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.2,
					vibratoDelay: 0,
					vibratoSpeed: 30,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
					],
					granular: 2,
					grainSize: 50,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					panDelay: 0,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					algorithm: "1←3 2←4",
					feedbackType: "3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 3,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "granular",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "vibratoDepth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "pitch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.8,
							discrete: false,
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "echoSustain",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 1,
							perEnvelopeUpperBound: 1.3,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 16,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Sand Snare",
				generalMidi: false,
				tags: ["fm", "fm6op", "eggfry", "snare"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 8 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 4 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 4 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 4 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 8 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 4 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 4 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 11.3137 },
					],
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "bitcrusher", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 8 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2.8284 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 8 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2.8284 },
					],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 0,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "Custom",
					feedbackAmplitude: 2,
					customFeedback: { mods: [[], [2], [5], [], [], [5, 3]] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "18×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "128×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
							index: 4,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "reverb",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.2,
							discrete: false,
						},
						{
							target: "echoSustain",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Glass Hat",
				generalMidi: false,
				tags: ["spectrum", "eggfry"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 16000, linearGain: 4 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 2 },
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 16000, linearGain: 4 },
						{ type: "peak", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2 },
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
					],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "distortion", "chorus", "ring mod"],
					detuneCents: -30,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 6727.17, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 6727.17, linearGain: 4 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 4000, linearGain: 2.8284 },
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					ringMod: 0,
					ringModHz: 97,
					ringModWaveformIndex: 0,
					ringModPulseWidth: 10,
					ringModHzOffset: 50,
					distortion: 43,
					aliases: false,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: -12,
					spectrum: [
						14, 29, 43, 57, 71, 71, 57, 57, 43, 29, 71, 57, 43, 71, 29, 71, 57, 100, 71,
						57, 71, 71, 71, 71, 29, 71, 71, 71, 57, 71,
					],
					unison: "none",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
		]),
	},
	{
		name: "august's presets",
		presets: toNameMap([
			{
				name: "shaky bass",
				generalMidi: false,
				tags: ["chip", "customchip", "august"],
				settings: {
					type: "custom chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 1414.21, linearGain: 1.4142 }],
					effects: ["transition type", "vibrato", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 10,
					chorus: 100,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 0,
						"1": -4,
						"2": -9,
						"3": -12,
						"4": -14,
						"5": -16,
						"6": -19,
						"7": -20,
						"8": -21,
						"9": -22,
						"10": -24,
						"11": -24,
						"12": -23,
						"13": -24,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -24,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -24,
						"25": -22,
						"26": -21,
						"27": -20,
						"28": -19,
						"29": -16,
						"30": -14,
						"31": -12,
						"32": -9,
						"33": -4,
						"34": 0,
						"35": 5,
						"36": 10,
						"37": 12,
						"38": 15,
						"39": 17,
						"40": 20,
						"41": 21,
						"42": 22,
						"43": 23,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 24,
						"51": 24,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 23,
						"56": 22,
						"57": 21,
						"58": 20,
						"59": 17,
						"60": 15,
						"61": 12,
						"62": 10,
						"63": 5,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "y.a. bell",
				generalMidi: false,
				tags: ["fm", "fm4op", "august"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 2,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 2,
						},
					],
					effects: ["chord type", "note filter", "chorus", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~2×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "y.a. trumpet",
				generalMidi: false,
				tags: ["fm", "fm4op", "august", "featured"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 2.8284,
						},
					],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 43,
					reverb: 55,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "icicle synth",
				generalMidi: false,
				tags: ["pickedstring", "august"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.25 },
					],
					eqSubFilters1: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1 },
					],
					eqSubFilters2: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.25 },
					],
					eqSubFilters3: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.25 },
					],
					eqSubFilters4: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.25 },
					],
					eqSubFilters8: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 62.5,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 210.22, linearGain: 0.25 },
					],
					effects: ["chord type", "distortion", "bitcrusher", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					monoChordTone: 1,
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 57, 57, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 29,
					envelopes: [],
				},
			},
			{
				name: "icicle synth 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "august"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["pitch shift", "vibrato", "note filter", "reverb"],
					pitchShiftSemitones: 24,
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 4,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 1125, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 1125, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "icicle violin",
				generalMidi: false,
				tags: ["chip", "chipwave", "august"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 }],
					effects: ["vibrato", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					reverb: 100,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 96,
					wave: "1/4 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 4,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "shaky ahh ohh",
				generalMidi: false,
				tags: ["harmonics", "august"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 1444.32, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 5,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "vibrato", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 86, 14, 14, 0, 0, 0, 14, 29, 29, 14, 0, 14, 29, 29, 14, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "dirty ePiano",
				generalMidi: false,
				tags: ["pickedstring", "august"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.1768 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.1768 }],
					effects: ["note filter", "distortion", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.3536 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 9513.66, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 62.5, linearGain: 0.3536 },
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					harmonics: [
						100, 100, 100, 86, 100, 100, 100, 100, 100, 100, 100, 100, 71, 43, 43, 43,
						29, 29, 29, 14, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "custom",
					unisonVoices: 2,
					unisonSpread: 0.01,
					unisonOffset: 0,
					unisonExpression: 1,
					unisonSign: 0.7,
					stringSustain: 79,
					envelopes: [],
				},
			},
			{
				name: "dirty viola",
				generalMidi: false,
				tags: ["fm", "fm4op", "august", "featured"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 0.1768 },
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 4 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 6727.17, linearGain: 2 },
					],
					effects: ["note filter", "distortion", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					reverb: 77,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					algorithm: "1←(2 3 4)",
					feedbackType: "3⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "feedbackAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "distorted kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "august", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 0.5,
						},
					],
					effects: ["pitch shift", "note filter", "distortion", "bitcrusher"],
					pitchShiftSemitones: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "dubstep kick",
				generalMidi: false,
				tags: ["fm", "fm4op", "august", "kick"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.5 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 1 },
						{ type: "peak", cutoffHz: 74.33, linearGain: 1.4142 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 },
					],
					effects: ["transition type", "pitch shift", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.125 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2000, linearGain: 0.125 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4",
					feedbackType: "2→4",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "19×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
		]),
	},
];
